export const templateRestaurante = {

config:{
cor_primaria:"#2b1e16",
tipo_fundo:"solido",
bg_size:"cover",
bg_pos_x:50,
bg_pos_y:50,
fonte_principal:"Montserrat"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"RESTAURANTE SABOR DA CASA",
pos_x:40,
pos_y:40,
estilo:{
fontSize:30,
color:"#f5d27a",
fontFamily:"Playfair Display",
fontWeight:"900",
letterSpacing:"2px"
}
},

{
id:2,
tipo:"texto",
conteudo:"CARDÁPIO",
pos_x:140,
pos_y:90,
estilo:{
fontSize:22,
color:"#ffffff",
fontFamily:"Montserrat",
fontWeight:"bold"
}
},

{
id:3,
tipo:"texto",
conteudo:"──────────────",
pos_x:120,
pos_y:110,
estilo:{
fontSize:18,
color:"#f5d27a"
}
},

{
id:4,
tipo:"texto",
conteudo:"PRATOS PRINCIPAIS",
pos_x:90,
pos_y:150,
estilo:{
fontSize:18,
color:"#f5d27a",
fontFamily:"Montserrat",
fontWeight:"bold"
}
},

{
id:5,
tipo:"texto",
conteudo:"🍽 Filé Mignon ao Molho Madeira",
pos_x:30,
pos_y:190,
estilo:{
fontSize:14,
color:"#ffffff",
fontFamily:"Montserrat"
}
},

{
id:6,
tipo:"texto",
conteudo:"R$ 59,90",
pos_x:260,
pos_y:190,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:7,
tipo:"texto",
conteudo:"🍗 Frango Grelhado com Legumes",
pos_x:30,
pos_y:220,
estilo:{
fontSize:14,
color:"#ffffff"
}
},

{
id:8,
tipo:"texto",
conteudo:"R$ 39,90",
pos_x:260,
pos_y:220,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:9,
tipo:"texto",
conteudo:"🍝 Espaguete à Bolonhesa",
pos_x:30,
pos_y:250,
estilo:{
fontSize:14,
color:"#ffffff"
}
},

{
id:10,
tipo:"texto",
conteudo:"R$ 34,90",
pos_x:260,
pos_y:250,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:11,
tipo:"texto",
conteudo:"BEBIDAS",
pos_x:130,
pos_y:300,
estilo:{
fontSize:18,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:12,
tipo:"texto",
conteudo:"🥤 Refrigerante Lata",
pos_x:30,
pos_y:330,
estilo:{
fontSize:14,
color:"#ffffff"
}
},

{
id:13,
tipo:"texto",
conteudo:"R$ 6,00",
pos_x:260,
pos_y:330,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:14,
tipo:"texto",
conteudo:"🍹 Suco Natural",
pos_x:30,
pos_y:360,
estilo:{
fontSize:14,
color:"#ffffff"
}
},

{
id:15,
tipo:"texto",
conteudo:"R$ 9,00",
pos_x:260,
pos_y:360,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:16,
tipo:"texto",
conteudo:"SOBREMESAS",
pos_x:120,
pos_y:410,
estilo:{
fontSize:18,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:17,
tipo:"texto",
conteudo:"🍰 Pudim de Leite",
pos_x:30,
pos_y:440,
estilo:{
fontSize:14,
color:"#ffffff"
}
},

{
id:18,
tipo:"texto",
conteudo:"R$ 12,00",
pos_x:260,
pos_y:440,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
},

{
id:19,
tipo:"texto",
conteudo:"🍨 Sorvete Artesanal",
pos_x:30,
pos_y:470,
estilo:{
fontSize:14,
color:"#ffffff"
}
},

{
id:20,
tipo:"texto",
conteudo:"R$ 10,00",
pos_x:260,
pos_y:470,
estilo:{
fontSize:14,
color:"#f5d27a",
fontWeight:"bold"
}
}

]

};